import { Pharmacy } from "@intocare/medication/medication-data";

import * as pharmacies from "../actions/pharmacies.data";

export interface State {
	pharmacies: {
		data: Pharmacy[];
		loading: boolean;
		loaded: boolean;
	};
}

export const initialState: State = {
	pharmacies: {
		data: [],
		loading: false,
		loaded: false,
	},
};

export function reducer(state = initialState, action: pharmacies.Actions): State {
	let index: number;
	switch (action.type) {
		case pharmacies.UPDATE_PHARMACY:
			index = state.pharmacies.data.findIndex((pharmacy) => pharmacy.id === action.payload.data.id);

			return {
				...state,
				pharmacies: {
					...state.pharmacies,
					data: [
						...state.pharmacies.data.slice(0, index),
						action.payload.data,
						...state.pharmacies.data.slice(index + 1),
					],
				},
			};
		case pharmacies.ADD_PHARMACY:
			return {
				...state,
				pharmacies: {
					...state.pharmacies,
					data: [...state.pharmacies.data, action.payload.data],
				},
			};
		case pharmacies.LOADING_PHARMACIES:
			return {
				...state,
				pharmacies: {
					...state.pharmacies,
					loading: true,
					loaded: false,
				},
			};
		case pharmacies.SET_PHARMACIES:
			return {
				...state,
				pharmacies: {
					loading: false,
					loaded: true,
					data: action.payload.data,
				},
			};
		default:
			return state;
	}
}

export const getPharmacies = (state: State) => state.pharmacies;
